
import React, {useState} from 'react';
import './Plane.css';
import './PlaneDesc.css'

const Plane = (props) => {
    const {planeID, lat, lng, color, direction, elev, speed } = props;
    const [isShown, setIsShown] = useState(false);

    return (
      <div>

        <div onMouseEnter={() => setIsShown(true)} onMouseLeave={() => setIsShown(false)}>
          <i className="plane" style={{ borderColor:color, cursor: 'pointer', transform: `rotate(${-135+direction}deg)`,WebkitTransform: `rotate(${-135+direction}deg)`}}></i>
        </div>

        <div>
          {isShown && (
            <div className='box arrow-top' style = {{fontSize:'13px'}}>
              <div style = {{color:'#f0c463', fontWeight:600}}> {planeID} </div>
              {/* Need to textAlign: right and maybe do display: inline*/}
              Lat:  &nbsp; &nbsp; &nbsp; {lat}<br/>
              Lng:  &nbsp; &nbsp; {lng}<br/>
              Elev: &nbsp; &nbsp; {elev}m<br/>
              Speed: {speed}m/s
            </div>
          )} 
        </div>

      </div>
    );
  };

  export default Plane;
